import React, { PropTypes as pt } from 'react';
import classNames from 'classnames';

const Element = ({ element, ...props }) => element === 'input' ? <input {...props} /> : <textarea {...props} />;

class Input extends React.Component {
    handleChange = e => this.props.onChange(e.target.name, e.target.value);

    render() {
        const {
            name,
            value,
            id,
            label,
            disabled,
            type,
            element,
            error,
            horizontal,
            rows,
            readOnly,
            help,
            placeholder,
        } = this.props;
        const classes = classNames({
            'form-group': true,
            'has-error has-danger': !!error,
        });
        const labelClasses = classNames({
            'control-label': true,
            'col-md-4': horizontal,
        });
        const formControlWrapperClasses = classNames({
            'col-md-8': horizontal,
        });
        const formattedError = Array.isArray(error) ? error[0] : error;
        const ariaLabel = label || placeholder || name;
        const inputClasses = classNames({
            'form-control': true,
            'is-invalid': !!error,
        });
        return (
            <div className={classes}>
                {label && <label htmlFor={id} className={labelClasses}>{label}</label>}
                <div className={formControlWrapperClasses}>
                    <Element
                        element={element}
                        id={id}
                        type={type}
                        className={inputClasses}
                        name={name}
                        value={value || ''}
                        onChange={this.handleChange}
                        disabled={disabled}
                        rows={rows}
                        readOnly={readOnly}
                        placeholder={placeholder}
                        aria-label={!label ? ariaLabel : undefined}
                        aria-invalid={!!error}
                    />
                    {formattedError && <small className="help-block mb-none text-danger">{formattedError}</small>}
                    {help && <div><small className="help-block mb-none">{help}</small></div>}
                </div>
            </div>
        );
    }
}

Input.propTypes = {
    name: pt.string.isRequired,
    label: pt.string,
    id: pt.string.isRequired,
    value: pt.string,
    onChange: pt.func.isRequired,
    disabled: pt.bool.isRequired,
    type: pt.string,
    element: pt.string.isRequired,
    error: pt.oneOfType([pt.string, pt.array]),
    horizontal: pt.bool,
    rows: pt.number.isRequired,
    readOnly: pt.bool,
    help: pt.node,
    placeholder: pt.string,
};

Input.defaultProps = {
    disabled: false,
    readOnly: false,
    value: '',
    type: 'text',
    element: 'input',
    horizontal: true,
    rows: 3,
};

export default Input;



// WEBPACK FOOTER //
// ./src/incab/common/components/form/Input.jsx